import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@services/auth/authentication.service';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import { SessionsRequestService } from '@services/sessions/sessions.request.service';

@Component({
  selector: 'app-sessions-notif-emails',
  templateUrl: './sessions-notif-emails.component.html',
  styleUrls: ['./sessions-notif-emails.component.scss'],
})
export class SessionsNotifEmailsComponent implements OnInit, OnDestroy {
  sessions = undefined;
  selectedSessions = [];

  settings = {
    collaborator: {
      added: {
        you: undefined,
        someone: undefined,
      },
      requested: undefined,
    },
    comment: {
      added: undefined,
      mentioned: undefined,
      replied: undefined,
    },
  };

  constructor(
    private bus: BusService,
    private events: EventsService,
    private auth: AuthenticationService,
    private _: SessionsRequestService,
  ) {}

  ngOnInit() {
    this.bus.subscribe(
      this.events.received.data.session.adminAll.success,
      this.updateSessions,
      this,
    );
    this.bus.publish(this.events.requested.data.session.adminAll);
  }

  updateSessions(sessions) {
    this.sessions = sessions;
  }

  toggleSelection(session) {
    if (this.selectedSessions.includes(session)) {
      this.selectedSessions = this.selectedSessions.filter(s => s != session);
    } else this.selectedSessions.push(session);

    this.updateSettings();
  }

  updateSettings() {
    this.settings.collaborator.added.you = this.aggregateValue(
      'collaborator.added.you',
    );
    this.settings.collaborator.added.someone = this.aggregateValue(
      'collaborator.added.someone',
    );
    this.settings.collaborator.requested = this.aggregateValue(
      'collaborator.requested',
    );
    this.settings.comment.added = this.aggregateValue('comment.added');
    this.settings.comment.mentioned = this.aggregateValue('comment.mentioned');
    this.settings.comment.replied = this.aggregateValue('comment.replied');
  }

  sessionValue(key, session) {
    if (session.config.emails && session.config.emails.notif) {
      const _settings = session.config.emails.notif;
      if (key == 'collaborator.added.you')
        return _settings.collaborator.added.you;
      if (key == 'collaborator.added.someone')
        return _settings.collaborator.added.someone;
      if (key == 'collaborator.requested')
        return _settings.collaborator.requested;
      if (key == 'comment.added') return _settings.comment.added;
      if (key == 'comment.mentioned') return _settings.comment.mentioned;
      if (key == 'comment.replied') return _settings.comment.replied;
    }

    return true;
  }

  aggregateValue(key) {
    if (this.selectedSessions.length === 0) return undefined;

    const trues = this.selectedSessions.filter(
      session => this.sessionValue(key, session) === true,
    );
    const falses = this.selectedSessions.filter(
      session => this.sessionValue(key, session) === false,
    );

    if (falses.length === 0) return true;
    if (trues.length === 0) return false;
    return undefined;
  }

  set(key, value) {
    const _default = {
      notif: {
        collaborator: { added: { you: true, someone: true }, requested: true },
        comment: { added: true, mentioned: true, replied: true },
      },
    };
    this.selectedSessions.forEach(session => {
      if (!session.config.emails) session.config.emails = _default;
      if (!session.config.emails.notif)
        session.config.emails.notif = _default.notif;

      if (key == 'collaborator.added.you')
        session.config.emails.notif.collaborator.added.you = value;
      if (key == 'collaborator.added.someone')
        session.config.emails.notif.collaborator.added.someone = value;
      if (key == 'collaborator.requested')
        session.config.emails.notif.collaborator.requested = value;
      if (key == 'comment.added')
        session.config.emails.notif.comment.added = value;
      if (key == 'comment.mentioned')
        session.config.emails.notif.comment.mentioned = value;
      if (key == 'comment.replied')
        session.config.emails.notif.comment.replied = value;
    });

    this.bus.publish(
      this.events.requested.data.session.updateEmailNotifSettings,
      {
        ids: this.selectedSessions.map(session => session._id),
        key: key,
        value: value,
      },
    );

    this.updateSettings();
  }

  toggleAll() {
    if (this.selectedSessions.length === this.sessions.length)
      this.selectedSessions = [];
    else this.selectedSessions = this.sessions;
  }

  ngOnDestroy() {
    this.bus.unsubscribe(
      this.events.received.data.session.adminAll.success,
      this.updateSessions,
    );
  }
}
